import React from "react";
import { ShieldCheck, ShieldAlert } from "lucide-react";

export const GRADE_COLOR = { A: "#2E7D32", B: "#4C8C2B", C: "#E39629", D: "#D55816", E: "#A5300F" };
export const SIG_COLOR = { Informational: "#9AA0A6", Notable: "#E39629", Critical: "#A5300F" };

export function PostureDial({ score, grade, size = 150 }) {
  const s = score == null ? 0 : score;
  const color = GRADE_COLOR[grade] || "#9AA0A6";
  const r = (size - 18) / 2;
  const circ = 2 * Math.PI * r;
  const off = circ * (1 - s / 100);
  return (
    <div className="relative inline-flex items-center justify-center" data-testid="posture-dial">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#F0EAE1" strokeWidth={10} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={10}
          strokeDasharray={circ} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.9s ease" }} />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-display font-bold" style={{ fontSize: size * 0.34, color }}>{grade || "—"}</span>
        <span className="text-xs text-[#8A8175]">{score == null ? "No scan" : `${score} / 100`}</span>
      </div>
    </div>
  );
}

export function GradeChip({ grade, score }) {
  const c = GRADE_COLOR[grade] || "#9AA0A6";
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-bold rounded"
      style={{ color: c, background: `${c}14`, border: `1px solid ${c}33` }}>
      {grade || "—"}{score != null && <span className="font-mono opacity-70">{score}</span>}
    </span>
  );
}

export function SignificanceChip({ level }) {
  const c = SIG_COLOR[level] || "#9AA0A6";
  return (
    <span className="inline-flex items-center px-2 py-0.5 text-[11px] font-bold rounded uppercase tracking-wide"
      style={{ color: c, background: `${c}14`, border: `1px solid ${c}33` }}>{level}</span>
  );
}

export function VerifyChip({ verified, active = true }) {
  if (verified && active)
    return <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#2E7D32]"><ShieldCheck className="w-3.5 h-3.5" /> Verified</span>;
  if (verified && !active)
    return <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#E39629]"><ShieldAlert className="w-3.5 h-3.5" /> Auth expired</span>;
  return <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#A5300F]"><ShieldAlert className="w-3.5 h-3.5" /> Unverified</span>;
}
